// (C) Copyright 2020 MediaWink, LLC

export const selectLastmodtime = (state) => state.undo.present.private.lastmodtime;
